export default __webpack_public_path__ + "static/media/bg-info-block.49a3da89.jpg";